import { axios } from '@/lib/axios'
import { useQuery } from '@tanstack/react-query'
import { CompnayDetail } from '../types'

const getCompanyDetail = (): Promise<CompnayDetail> => {
  return axios.get('/company')
}

export const useCompanyDetail = () => {
  return useQuery({
    queryKey: ['companyDetail'],
    queryFn: getCompanyDetail,
  })
}
